import {
  
  GET_USER_AGREEMENTS_SUCCESS, 
  USER_AGREEMENTS_API_ERROR

} from "./actionTypes"

const INIT_STATE = {
  userAgreementList: [],
  error: {}
}

const userAgreement = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_USER_AGREEMENTS_SUCCESS:
      return {
        ...state,
        userAgreementList: action.payload,
      }
    case USER_AGREEMENTS_API_ERROR:
      return {
        ...state,
        error: action.payload,
      }

    default:

      return state

  }
}

export default userAgreement